import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBox, FiTrendingUp, FiCreditCard, FiArrowRight, FiCheck, FiFacebook, FiTwitter, FiLinkedin, FiStar, FiHelpCircle, FiChevronDown, FiBarChart2, FiXCircle, FiCheckCircle, FiUserPlus, FiShoppingBag, FiTruck, FiUsers, FiGift, FiInstagram, FiWifiOff } from 'react-icons/fi';
import logo from '../assets/logo.png';
import logoWhite from '../assets/logo-white.png';

const LandingNavbar = () => (
  <nav className="bg-white/90 backdrop-blur-lg shadow-sm fixed w-full z-50 transition-all duration-300">
    <div className="container mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
      <Link to="/" className="flex items-center">
        <img src={logo} alt="Jaapand-e" className="h-8 sm:h-12" />
      </Link>
      <div>
        <Link to="/login" className="text-gray-600 hover:text-brand-blue font-medium mx-1 sm:mx-3 text-sm sm:text-base transition-colors">Connexion</Link>
        <Link to="/register" className="bg-brand-green text-white font-bold py-2.5 px-5 rounded-full hover:bg-green-600 transition-all shadow-md hover:shadow-lg text-sm sm:text-base">
          <span className="hidden sm:inline">Créer un compte</span>
          <span className="sm:hidden">S'inscrire</span>
        </Link>
      </div>
    </div>
  </nav>
);

const FeatureCard = ({ icon, title, description }) => (
  <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100 flex flex-col items-start text-left group h-full">
    <div className="text-brand-green bg-green-50 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-brand-green group-hover:text-white transition-colors duration-300">{icon}</div>
    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-brand-green transition-colors">{title}</h3>
    <p className="text-gray-500 leading-relaxed text-base">{description}</p>
  </div>
);

const LandingPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [billingCycle, setBillingCycle] = useState('monthly');

  return (
    <div className="bg-white text-gray-800 font-sans overflow-x-hidden">
      <LandingNavbar />

      {/* Hero Section */}
      <header className="relative pt-32 md:pt-48 pb-32 overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-blue-50/50 to-white -z-10"></div>
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-green-50/30 to-transparent -z-10 rounded-bl-[100px]"></div>
        
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div className="text-center md:text-left">
             {/* Bannière Offre de Lancement */}
             <div className="mb-8">
               <div className="inline-flex items-center bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-5 py-3 rounded-xl shadow-lg transform -rotate-1 hover:rotate-0 transition-transform duration-300 cursor-default">
                  <FiGift className="mr-2 text-xl" />
                  <span className="font-bold text-sm md:text-base">Offre Lancement : Premium GRATUIT (2 mois) pour les 20 premiers !</span>
               </div>
             </div>

             {/* Badge */}
             <div className="inline-block px-4 py-1.5 mb-6 bg-blue-100 text-brand-blue rounded-full text-sm font-semibold tracking-wide uppercase">
                Nouveau au Sénégal 🇸🇳
             </div>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight font-poppins tracking-tight">
              Votre boutique,<br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-blue to-brand-green">plus simple.</span>
            </h2>
            <p className="text-gray-600 mt-8 text-lg md:text-xl max-w-xl mx-auto md:mx-0 leading-relaxed">
              Arrêtez de perdre du temps et de l'argent avec vos carnets. Jaapand-e centralise votre stock, vos ventes et vos dettes sur votre téléphone.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4">
              <Link to="/register" className="bg-brand-green text-white font-bold py-4 px-10 rounded-full text-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-green-500/30 transform hover:-translate-y-1 flex items-center">
                Démarrer gratuitement <FiArrowRight className="ml-2" />
              </Link>
            </div>
             <p className="mt-4 text-sm text-gray-400">Aucune carte bancaire requise • Annulable à tout moment</p>
          </div>
          
          <div className="relative mt-16 md:mt-0 group px-4 md:px-12 perspective-1000">
             {/* Decorative blobs */}
             <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[140%] bg-gradient-to-tr from-blue-100/40 via-green-100/40 to-purple-100/40 rounded-full blur-3xl -z-10"></div>

            {/* Carte flottante 1 - Ventes */}
            <div className="absolute top-8 -left-4 md:-left-12 w-60 bg-white/80 backdrop-blur-md p-4 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white/60 transition-all duration-500 hover:scale-105 z-30 animate-float-slow">
              <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center text-brand-green shadow-sm"><FiTrendingUp size={20} /></div>
                  <div>
                      <p className="font-bold text-sm text-gray-800">Ventes du jour</p>
                      <p className="text-[10px] font-semibold text-green-600 bg-green-50 px-2 py-0.5 rounded-full inline-block">En hausse 🚀</p>
                  </div>
              </div>
              <div className="flex items-baseline gap-1">
                <p className="text-2xl font-extrabold text-gray-900">150,000</p>
                <span className="text-xs font-medium text-gray-500">CFA</span>
              </div>
              <div className="w-full bg-gray-100 h-1.5 rounded-full mt-3 overflow-hidden">
                <div className="bg-brand-green h-full rounded-full w-[75%]"></div>
              </div>
            </div>

            {/* Carte flottante 2 - Stock */}
            <div className="absolute -bottom-6 -right-2 md:-right-8 w-60 bg-white/80 backdrop-blur-md p-4 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white/60 transition-all duration-500 hover:scale-105 z-30 animate-float-delayed">
               <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-red-500 rounded-full animate-ping"></div>
                    <p className="font-bold text-xs text-red-500 uppercase tracking-wide">Stock faible</p>
                  </div>
                  <span className="text-[10px] text-gray-400">Il y a 2m</span>
               </div>
              <div className="flex items-center gap-3 bg-red-50/50 p-2 rounded-xl border border-red-100">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center text-xl shadow-sm">🧼</div>
                  <div>
                      <p className="text-gray-800 font-bold text-sm">Savon Marseille</p>
                      <p className="text-xs text-gray-500">Reste : <span className="font-bold text-red-600">3 unités</span></p>
                  </div>
              </div>
            </div>

            {/* Image principale avec effet de cadre */}
            <div className="relative transform transition-transform duration-700 hover:rotate-1 hover:scale-[1.01] z-10">
              {/* Ombre colorée derrière */}
              <div className="absolute inset-4 bg-gradient-to-tr from-brand-blue to-brand-green rounded-[2.5rem] blur-2xl opacity-20 group-hover:opacity-40 transition-opacity duration-500 -z-10"></div>
              
              {/* Cadre du téléphone */}
              <div className="relative bg-white rounded-[2.5rem] p-2 shadow-2xl ring-1 ring-gray-200/50">
                  {/* Notch simulé */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-5 bg-gray-100 rounded-b-xl z-20 opacity-50"></div>
                  <img src="/app-screenshot.png" alt="Aperçu du tableau de bord de Jaapand-e" className="rounded-[2rem] w-full h-auto border border-gray-100 shadow-inner" />
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Before/After Section */}
      <section id="before-after" className="py-32 bg-gray-900 text-white relative overflow-hidden">
         {/* Background pattern */}
         <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#444cf7 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
         
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-3xl md:text-5xl font-bold font-poppins mb-6">Arrêtez de gérer votre boutique <br/><span className="text-gray-500">comme en 1990</span></h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-16">Le carnet et la calculatrice vous coûtent du temps et de l'argent. Il existe une meilleure façon de faire.</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 text-left max-w-5xl mx-auto">
            {/* Avant */}
            <div className="bg-gray-800/50 backdrop-blur-sm p-10 rounded-3xl border border-gray-700 hover:border-red-500/30 transition-colors duration-300">
              <img src="/before-illustration.png" alt="Gestion manuelle avec carnet" className="w-full h-48 object-cover rounded-2xl mb-8 opacity-80 border border-gray-700 grayscale-[30%]" />
              <div className="flex items-center mb-8">
                  <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center text-red-500 mr-4"><FiXCircle size={24} /></div>
                  <h3 className="text-2xl font-bold">Avant Jaapand-e</h3>
              </div>
              <ul className="space-y-6">
                <li className="flex items-start text-gray-300"><span className="text-red-500 mr-4 mt-1">✕</span><span>Dettes clients oubliées et argent perdu.</span></li>
                <li className="flex items-start text-gray-300"><span className="text-red-500 mr-4 mt-1">✕</span><span>Aucune idée du stock réel, ventes manquées.</span></li>
                <li className="flex items-start text-gray-300"><span className="text-red-500 mr-4 mt-1">✕</span><span>Calculs de bénéfices à la main, longs et souvent faux.</span></li>
                <li className="flex items-start text-gray-300"><span className="text-red-500 mr-4 mt-1">✕</span><span>Impossible de savoir quels produits marchent le mieux.</span></li>
              </ul>
            </div>
            {/* Après */}
            <div className="bg-gradient-to-br from-brand-green/20 to-brand-blue/20 backdrop-blur-sm p-10 rounded-3xl border border-brand-green/30 shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/20 rounded-full blur-3xl -mr-16 -mt-16"></div>
              <img src="/after-illustration.png" alt="Gestion moderne avec Jaapand-e" className="w-full h-48 object-cover rounded-2xl mb-8 shadow-lg border border-white/10 relative z-10" />
              <div className="flex items-center mb-8">
                  <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center text-white mr-4 shadow-lg shadow-green-500/30"><FiCheck size={24} /></div>
                  <h3 className="text-2xl font-bold text-white">Avec Jaapand-e</h3>
              </div>
              <ul className="space-y-6">
                <li className="flex items-start"><span className="text-brand-green mr-4 mt-1 bg-white rounded-full p-0.5"><FiCheck size={12} /></span><span className="font-medium">Dettes suivies et payées grâce aux rappels WhatsApp (SMS bientôt).</span></li>
                <li className="flex items-start"><span className="text-brand-green mr-4 mt-1 bg-white rounded-full p-0.5"><FiCheck size={12} /></span><span className="font-medium">Stock mis à jour en temps réel, alertes automatiques.</span></li>
                <li className="flex items-start"><span className="text-brand-green mr-4 mt-1 bg-white rounded-full p-0.5"><FiCheck size={12} /></span><span className="font-medium">Bénéfices calculés instantanément sur chaque vente.</span></li>
                <li className="flex items-start"><span className="text-brand-green mr-4 mt-1 bg-white rounded-full p-0.5"><FiCheck size={12} /></span><span className="font-medium">Rapports clairs pour prendre les bonnes décisions.</span></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-32 bg-gray-50 relative overflow-hidden">
        {/* Background blobs */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
            <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl -z-10"></div>
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-green-100/40 rounded-full blur-3xl -z-10"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-20">
            <span className="text-brand-blue font-bold tracking-wider uppercase text-sm">Simple et Rapide</span>
            <h3 className="text-3xl md:text-5xl font-bold text-gray-900 font-poppins mt-3 mb-6 tracking-tight">Démarrer en 3 étapes</h3>
            <p className="text-gray-500 text-xl max-w-2xl mx-auto">Pas besoin d'être un expert en informatique. Jaapand-e est conçu pour être utilisé par tout le monde.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative max-w-6xl mx-auto">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-gray-200 via-brand-blue/20 to-gray-200 -z-10"></div>

            {/* Step 1 */}
            <div className="relative flex flex-col items-center text-center group">
              <div className="w-24 h-24 bg-white rounded-3xl shadow-lg shadow-blue-900/5 border border-gray-100 flex items-center justify-center mb-8 relative z-10 group-hover:scale-110 transition-transform duration-300">
                <div className="text-brand-blue bg-blue-50 w-14 h-14 rounded-2xl flex items-center justify-center text-2xl"><FiUserPlus /></div>
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-brand-blue text-white rounded-full flex items-center justify-center font-bold border-4 border-white shadow-sm">1</div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Créez votre compte</h4>
              <p className="text-gray-500 leading-relaxed">Inscrivez-vous gratuitement en moins de 2 minutes. Aucune carte bancaire requise.</p>
            </div>

            {/* Step 2 */}
            <div className="relative flex flex-col items-center text-center group">
              <div className="w-24 h-24 bg-white rounded-3xl shadow-lg shadow-green-900/5 border border-gray-100 flex items-center justify-center mb-8 relative z-10 group-hover:scale-110 transition-transform duration-300">
                <div className="text-brand-green bg-green-50 w-14 h-14 rounded-2xl flex items-center justify-center text-2xl"><FiBox /></div>
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-brand-green text-white rounded-full flex items-center justify-center font-bold border-4 border-white shadow-sm">2</div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Ajoutez vos produits</h4>
              <p className="text-gray-500 leading-relaxed">Saisissez votre stock ou importez-le simplement depuis Excel. Organisez votre boutique.</p>
            </div>

            {/* Step 3 */}
            <div className="relative flex flex-col items-center text-center group">
              <div className="w-24 h-24 bg-white rounded-3xl shadow-lg shadow-purple-900/5 border border-gray-100 flex items-center justify-center mb-8 relative z-10 group-hover:scale-110 transition-transform duration-300">
                <div className="text-purple-600 bg-purple-50 w-14 h-14 rounded-2xl flex items-center justify-center text-2xl"><FiTrendingUp /></div>
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center font-bold border-4 border-white shadow-sm">3</div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Vendez et Encaissez</h4>
              <p className="text-gray-500 leading-relaxed">Enregistrez vos ventes, suivez vos bénéfices et gérez vos clients en toute simplicité.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-32 bg-white relative" id="features">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="text-brand-blue font-bold tracking-wider uppercase text-sm">Fonctionnalités</span>
            <h3 className="text-3xl md:text-5xl font-bold text-gray-900 font-poppins mt-3 mb-6">Tout ce dont vous avez besoin</h3>
            <p className="text-gray-500 text-xl max-w-2xl mx-auto">Vendez, gérez, encaissez et pilotez votre activité depuis une seule application simple et intuitive.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border-2 border-brand-green/20 flex flex-col items-start text-left group h-full relative overflow-hidden">
                <div className="absolute top-0 right-0 bg-brand-green text-white text-xs font-bold px-3 py-1 rounded-bl-xl">NOUVEAU</div>
                <div className="text-brand-green bg-green-50 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-brand-green group-hover:text-white transition-colors duration-300"><FiShoppingBag size={28} /></div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-brand-green transition-colors">Boutique en Ligne</h3>
                <p className="text-gray-500 leading-relaxed text-base">Créez votre site e-commerce en un clic. Partagez le lien et recevez les commandes directement sur votre dashboard ou sur Whatsapp.</p>
            </div>
            <FeatureCard
              icon={<FiWifiOff size={28} />}
              title="Mode Hors Ligne"
              description="Continuez à vendre même sans internet. Vos données sont sauvegardées localement et synchronisées automatiquement dès le retour de la connexion."
            />
            <FeatureCard
              icon={<FiBarChart2 size={28} />}
              title="Encaissez Plus Vite"
              description="Suivez les dettes clients, enregistrez les paiements et envoyez des rappels par SMS (bientôt disponible) pour réduire vos impayés."
            />
            <FeatureCard
              icon={<FiBox size={28} />}
              title="Vendez Sans Rupture"
              description="Votre stock se met à jour automatiquement à chaque vente. Recevez des alertes pour ne jamais manquer une opportunité."
            />
            <FeatureCard
              icon={<FiTrendingUp size={28} />}
              title="Maîtrisez vos Dépenses"
              description="Loyer, salaires, transport... Enregistrez toutes vos charges pour avoir une vision claire de votre rentabilité."
            />
            <FeatureCard
              icon={<FiCreditCard size={28} />}
              title="Pilotez votre Activité"
              description="Avec des rapports simples et visuels, prenez les bonnes décisions pour augmenter vos ventes et vos bénéfices."
            />
            <FeatureCard
              icon={<FiTruck size={28} />}
              title="Gestion Fournisseurs"
              description="Suivez vos achats et vos dettes fournisseurs pour maintenir de bonnes relations et ne jamais manquer de stock."
            />
            <FeatureCard
              icon={<FiUsers size={28} />}
              title="Gestion d'Équipe"
              description="Invitez vos employés, définissez leurs rôles et suivez leurs performances de vente individuelles."
            />
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-32 bg-gray-50 relative">
        {/* Background shapes */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
            <div className="absolute top-1/4 -left-64 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl"></div>
            <div className="absolute bottom-1/4 -right-64 w-96 h-96 bg-green-200/30 rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-5xl font-bold text-gray-900 font-poppins mb-4">Des tarifs adaptés à votre activité</h3>
            <p className="text-gray-500 text-xl">Choisissez le plan qui vous convient. Sans engagement.</p>
          </div>

          {/* Toggle Mensuel / Annuel */}
          <div className="flex justify-center items-center mb-16">
            <div className="bg-white p-1 rounded-full border border-gray-200 shadow-sm flex items-center">
                <button
                onClick={() => setBillingCycle('monthly')}
                className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${billingCycle === 'monthly' ? 'bg-gray-900 text-white shadow-md' : 'text-gray-500 hover:text-gray-900'}`}
                >
                Mensuel
                </button>
                <button
                onClick={() => setBillingCycle('yearly')}
                className={`px-6 py-2 rounded-full text-sm font-bold transition-all flex items-center ${billingCycle === 'yearly' ? 'bg-gray-900 text-white shadow-md' : 'text-gray-500 hover:text-gray-900'}`}
                >
                Annuel <span className="ml-2 text-[10px] bg-green-500 text-white px-2 py-0.5 rounded-full">-15%</span>
                </button>
            </div>
          </div>

           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-7xl mx-auto items-stretch">
            {/* Plan Essentiel */}
            <div className="bg-white p-10 rounded-[2rem] border border-gray-100 shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col h-full">
              <div className="mb-8">
                  <h4 className="text-2xl font-bold text-gray-900">Essentiel</h4>
                  <p className="text-gray-500 mt-2">Pour bien démarrer</p>
              </div>
              <div className="mb-8">
                  <p className="text-5xl font-extrabold text-gray-900">Gratuit</p>
                  <p className="text-gray-400 text-sm mt-2">Pour toujours</p>
              </div>
              
              <ul className="space-y-4 text-gray-600 mb-10 flex-grow">
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-green-100 text-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Jusqu'à 25 produits</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-green-100 text-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Suivi des dépenses</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-green-100 text-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Carnet de clients</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-green-100 text-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Ventes et Stock</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-green-100 text-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Mode Hors Ligne</li>
              </ul>
              <Link to="/register" className="block w-full text-center bg-gray-50 text-gray-900 font-bold py-4 px-6 rounded-xl hover:bg-gray-100 transition-colors border border-gray-200">Commencer gratuitement</Link>
            </div>

            {/* Plan Pro - Mis en avant */}
            <div className="bg-gray-900 text-white p-10 rounded-[2rem] shadow-2xl border-4 border-brand-green relative transform lg:-translate-y-4 flex flex-col h-full z-10">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white text-sm font-bold px-4 py-1 rounded-full shadow-lg uppercase tracking-wide">Le plus populaire</div>
              <div className="mb-8">
                  <h4 className="text-2xl font-bold text-white">Pro</h4>
                  <p className="text-gray-400 mt-2">Pour accélérer votre croissance</p>
              </div>
              <div className="mb-8">
                  <p className="text-5xl font-extrabold text-white flex items-end">
                    {billingCycle === 'monthly' ? '7,500' : '75,000'} 
                    <span className="text-lg font-medium text-gray-400 mb-1 ml-2">F CFA/{billingCycle === 'monthly' ? 'mois' : 'an'}</span>
                  </p>
              </div>
              
              <ul className="space-y-4 text-gray-300 mb-10 flex-grow">
                <li className="flex items-center font-medium text-white"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Tout le plan Essentiel</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Jusqu'à 250 produits</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Import Excel/CSV</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Tickets de caisse pro et facture</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Rappels Dettes (WhatsApp & SMS*) <span className="text-gray-400 text-xs ml-1 italic">*En développement</span></li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Rapports de ventes</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center mr-3 text-xs"><FiCheck /></div> Gestion fournisseurs</li>
              </ul>
              <Link to={`/register?plan=pro&billingCycle=${billingCycle}`} className="block w-full text-center bg-brand-green text-white font-bold py-4 px-6 rounded-xl hover:bg-green-500 transition-all shadow-lg hover:shadow-green-500/30">
                Choisir le plan Pro
              </Link>
            </div>

            {/* Plan Premium */}
            <div className="bg-white p-10 rounded-[2rem] border border-gray-100 shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col h-full">
              <div className="mb-8">
                  <h4 className="text-2xl font-bold text-gray-900">Premium</h4>
                  <p className="text-gray-500 mt-2">Pour les boutiques structurées</p>
              </div>
              <div className="mb-8">
                  <p className="text-5xl font-extrabold text-gray-900 flex items-end">
                    {billingCycle === 'monthly' ? '25,000' : '250,000'}
                    <span className="text-lg font-medium text-gray-400 mb-1 ml-2">F CFA/{billingCycle === 'monthly' ? 'mois' : 'an'}</span>
                  </p>
              </div>
              
              <ul className="space-y-4 text-gray-600 mb-10 flex-grow">
                <li className="flex items-center font-medium text-gray-900"><div className="w-6 h-6 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-xs"><FiStar className="fill-current" /></div> Tout le plan Pro</li>
                <li className="flex items-center font-bold text-brand-blue"><div className="w-6 h-6 rounded-full bg-blue-100 text-brand-blue flex items-center justify-center mr-3 text-xs"><FiShoppingBag /></div> Boutique en ligne <span className="ml-2 text-[10px] bg-brand-green text-white px-2 py-0.5 rounded-full">Nouveau</span></li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-xs"><FiStar className="fill-current" /></div> Produits illimités</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-xs"><FiStar className="fill-current" /></div> Dettes fournisseurs</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-xs"><FiStar className="fill-current" /></div> Rapports avancés & exports</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-xs"><FiStar className="fill-current" /></div> Gestion d'équipe (Rôles)</li>
                <li className="flex items-center"><div className="w-6 h-6 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-xs"><FiStar className="fill-current" /></div> Support prioritaire</li>
              </ul>
              <Link to={`/register?plan=premium&billingCycle=${billingCycle}`} className="block w-full text-center bg-white border-2 border-gray-900 text-gray-900 font-bold py-4 px-6 rounded-xl hover:bg-gray-900 hover:text-white transition-colors">
                Choisir le plan Premium
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <h3 className="text-3xl md:text-5xl font-bold text-gray-900 font-poppins mb-4">Ils nous font confiance</h3>
            <p className="text-gray-500 text-xl">Découvrez ce que nos utilisateurs pensent de Jaapand-e.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100 hover:shadow-lg transition-shadow">
              <div className="flex text-yellow-400 mb-6">
                <FiStar className="fill-current" /><FiStar className="fill-current" /><FiStar className="fill-current" /><FiStar className="fill-current" /><FiStar className="fill-current" />
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-8">"La fonction de rappel dettes est magique. J'ai récupéré deux grosses dettes en une journée. L'abonnement Pro est déjà rentabilisé pour toute l'année !"</p>
              <div className="flex items-center mt-auto">
                <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden mr-4">
                    <img src="/khadija.jpg" alt="Khadija" className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">Khadija Doucouré</p>
                  <p className="text-sm text-gray-500">Gérante, Boutique de vêtements</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100 hover:shadow-lg transition-shadow lg:col-span-2">
              <div className="flex text-yellow-400 mb-6">
                <FiStar className="fill-current" /><FiStar className="fill-current" /><FiStar className="fill-current" /><FiStar className="fill-current" /><FiStar className="fill-current" />
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-8">"Avant, je passais mes soirées à faire mes comptes sur un carnet. Maintenant, je sais en temps réel combien j'ai vendu et quel est mon bénéfice. Je peux enfin me concentrer sur mes clients. C'est un gain de temps et une tranquillité d'esprit incroyables."</p>
              <div className="flex items-center mt-auto">
                <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden mr-4">
                    <img src="/lahad.png" alt="Abdou Lahad" className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">Abdou Lahad Gueye</p>
                  <p className="text-sm text-gray-500">Gérant, Boutique de Prêt-à-porter</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-32 bg-gray-50 relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
            <div className="absolute top-1/4 left-10 w-64 h-64 bg-blue-100/40 rounded-full blur-3xl -z-10"></div>
            <div className="absolute bottom-1/4 right-10 w-64 h-64 bg-green-100/40 rounded-full blur-3xl -z-10"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-brand-blue font-bold tracking-wider uppercase text-sm">Support</span>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 font-poppins mt-3 mb-4 tracking-tight">Questions fréquentes</h3>
            <p className="text-gray-500 text-lg max-w-2xl mx-auto">Vous avez des questions ? Nous avons les réponses pour vous aider à démarrer.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto items-start">
            {[
              { q: "Mes données sont-elles en sécurité ?", a: "Oui, absolument. La sécurité de vos données est notre priorité. Toutes les informations sont chiffrées et stockées sur des serveurs sécurisés. Vous êtes la seule personne à pouvoir y accéder." },
              { q: "L'application est-elle difficile à utiliser ?", a: "Non, Jaapand-e a été conçue pour être extrêmement simple et intuitive. Si vous savez utiliser WhatsApp, vous saurez utiliser Jaapand-e. Aucune compétence technique n'est requise." },
              { q: "Comment fonctionnent les rappels de dettes par SMS ?", a: "Cette fonctionnalité est en cours de développement. Bientôt, avec le plan Pro, vous pourrez envoyer des rappels SMS automatiques. En attendant, les rappels via WhatsApp sont disponibles." },
              { q: "Puis-je gérer les achats auprès de mes fournisseurs ?", a: "Oui, les plans Pro et Premium vous permettent de gérer vos fournisseurs, d'enregistrer vos achats pour mettre à jour votre stock automatiquement, et même de suivre vos dettes fournisseurs (plan Premium)." },
              { q: "Comment fonctionne la gestion d'équipe ?", a: "Vous pouvez inviter vos employés à rejoindre votre boutique. Chaque employé aura son propre accès avec des permissions limitées (par exemple, un vendeur ne verra pas les bénéfices), vous permettant de déléguer en toute sécurité." },
              { q: "Que se passe-t-il si je change de téléphone ?", a: "Aucun problème. Vos données sont sauvegardées dans le cloud. Il vous suffit de vous reconnecter avec vos identifiants sur votre nouveau téléphone pour tout retrouver." },
            ].map((item, index) => (
              <div key={index} className={`bg-white rounded-2xl transition-all duration-300 border ${openFaq === index ? 'border-brand-blue/30 shadow-lg shadow-blue-900/5 ring-1 ring-brand-blue/10' : 'border-gray-100 shadow-sm hover:shadow-md'}`}>
                <button 
                  onClick={() => setOpenFaq(openFaq === index ? null : index)} 
                  className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
                >
                  <span className={`text-lg font-bold transition-colors ${openFaq === index ? 'text-brand-blue' : 'text-gray-800'}`}>
                    {item.q}
                  </span>
                  <div className={`flex-shrink-0 ml-4 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${openFaq === index ? 'bg-brand-blue text-white rotate-180' : 'bg-gray-100 text-gray-500'}`}>
                    <FiChevronDown size={20} />
                  </div>
                </button>
                <div 
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-transparent">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="bg-gradient-to-r from-brand-blue to-blue-600 rounded-[3rem] shadow-2xl text-white p-12 md:p-24 text-center relative overflow-hidden">
            {/* Decorative circles */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/10 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
            
            <div className="relative z-10 max-w-3xl mx-auto">
                <h2 className="text-4xl md:text-6xl font-bold mb-8 font-poppins">Prêt à transformer votre commerce ?</h2>
                <p className="text-blue-100 text-xl mb-12 leading-relaxed">Rejoignez des centaines de commerçants qui font confiance à Jaapand-e pour une gestion simple, efficace et rentable.</p>
                <Link to="/register" className="bg-white text-brand-blue font-bold py-5 px-12 rounded-full text-xl hover:bg-gray-50 transition-all shadow-xl hover:shadow-white/20 transform hover:-translate-y-1 inline-flex items-center">
                    Lancez-vous maintenant <FiArrowRight className="ml-2" />
                </Link>
                <p className="mt-6 text-blue-200 text-sm">Essai gratuit • Pas de carte requise</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-16 border-t border-gray-800">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div className="col-span-1 lg:col-span-1">
              <img src={logoWhite} alt="Jaapand-e" className="h-10 mb-6 opacity-90" />
              <p className="text-sm leading-relaxed text-gray-500">La solution de gestion simplifiée conçue pour les boutiques et commerces du Sénégal. Gérez mieux, gagnez plus.</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">Produit</h4>
              <ul className="space-y-4 text-sm">
                  <li><a href="#features" className="hover:text-brand-green transition-colors">Fonctionnalités</a></li>
                  <li><a href="#pricing" className="hover:text-brand-green transition-colors">Tarifs</a></li>
                  <li><a href="#testimonials" className="hover:text-brand-green transition-colors">Témoignages</a></li>
                  <li><a href="#faq" className="hover:text-brand-green transition-colors">FAQ</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">Contact</h4>
              <ul className="space-y-4 text-sm">
                <li><a href="mailto:contact@jaapand-e.com" className="hover:text-brand-green transition-colors flex items-center">contact@jaapand-e.com</a></li>
                <li><a href="https://wa.me/221777854984" className="hover:text-brand-green transition-colors flex items-center">+221 77 785 49 84</a></li>
                <li className="text-gray-600">Dakar, Sénégal</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">Légal</h4>
              <ul className="space-y-4 text-sm">
                  <li><Link to="/privacy" className="hover:text-brand-green transition-colors">Politique de confidentialité</Link></li>
                  <li><Link to="/terms" className="hover:text-brand-green transition-colors">Conditions d'utilisation</Link></li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600">&copy; {new Date().getFullYear()} Jaapand-e. Made with ❤️ by Taysir Software.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="https://www.instagram.com/jaapand_e" className="text-gray-500 hover:text-white transition-colors"><FiInstagram size={20} /></a>
              <a href="https://www.facebook.com/profile.php?id=61588171792530" className="text-gray-500 hover:text-white transition-colors"><FiFacebook size={20} /></a>
              <a href="https://www.linkedin.com/company/111585219" className="text-gray-500 hover:text-white transition-colors"><FiLinkedin size={20} /></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
